<template>
  <div>
    <head-bottom />
    <div class="auto">
      <div class="container">
        <div class="auto-cards">
          <div class="auto-cards-left">
            <p
              class="auto-cards-left__title"
              v-html="sakta1.big_title"
            />
            <p
              class="auto-cards-left__sub"
              v-html="sakta1.description"
            />
            <div class="auto-cards-left__btn m_none">
              <polis-button :p_name="p_name" />
            </div>
          </div>
          <div class="auto-cards-right">
            <img
              :src="cdn + sakta1.image"
              alt=""
            >
            <div class="auto-cards-left__btn-mob d_none">
              <polis-button :p_name="p_name" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="object">
        <p
          class="object-title upper-text"
          v-html="sakta2.title"
        />
        <div
          v-for="(st, i) in sakta2.descriptions"
          :key="st"
          class="par"
        >
          <span v-if="i < 10">0{{ i + 1 }}.</span>
          <span v-else>{{ i + 1 }}.</span>
          <p
            class="object-par"
            v-html="st.description"
          />
        </div>
      </div>
      <div class="risk">
        <p
          class="risk-title upper-text"
          v-html="sakta3.title"
        />
        <div
          v-for="(st, i) in sakta3.descriptions"
          :key="st"
          class="par"
        >
          <span v-if="i < 10">0{{ i + 1 }}.</span>
          <span v-else>{{ i + 1 }}.</span>
          <p
            class="risk-par"
            v-html="st.description"
          />
        </div>
        <!-- <p class="risk-par"><span>01.</span>Дорожно-транспортное происшествие</p>
                <p class="risk-par"><span>02.</span>Угон, хищение</p>
                <p class="risk-par"><span>03.</span>Стихийные бедствия</p>
                <p class="risk-par"><span>04.</span>Противоправные действия третьих лиц</p>
                <p class="risk-par"><span>05.</span>Иные непредвиденные события</p> -->
      </div>
    </div>
    <!-- <timeBtn/> -->
    <div class="container">
      <div class="time">
        <p
          class="time-title"
          v-html="sakta4.big_title"
        />
        <p
          class="time-sub"
          v-html="sakta4.description"
        />
        <div class="time-btn">
          <time-btn :p_name="p_name" />
          <!-- <a href="https://kupipolis.kz/ru/paypartial"><button>Оформить полис</button></a> -->
        </div>
      </div>
    </div>
    <accordion />
    <question :p_name="p_name" />
    <slider-main-1 class="m_none" />
    <slider-main-mobile class="d_none" />
  </div>
</template>

<script>
import Question from "../components/Question.vue";
import HeadBottom from "../components/HeadBottom.vue";
import SliderMain1 from "@/components/SliderMain1-1.vue";
import SliderMainMobile from "@/components/SliderMainMobile.vue";
import accordion from "../components/accordion.vue";
import timeBtn from "../components/timeBtn.vue";
import PolisButton from "@/components/PolisButton.vue";
import axios from "axios";
import { mapState } from "vuex";
// import timeBtn from '../components/timeBtn.vue'
export default {
  components: {
    HeadBottom,
    Question,
    SliderMain1,
    accordion,
    SliderMainMobile,
    PolisButton,
    timeBtn,
  },
  data() {
    return {
      p_name: "Сакта 2.0 безопасные километры",
      sakta1: [],
      sakta2: [],
      sakta3: [],
      sakta4: [],
    };
  },
  computed: {
    ...mapState(["cdn"]),
  },
  created() {
    axios
      .get("V1/sakta")
      .then((response) => {
        this.sakta1 = response.data.data.first_block;
        this.sakta2 = response.data.data.second_block;
        this.sakta3 = response.data.data.third_block;
        this.sakta4 = response.data.data.fourth_block;
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/timeBtn.scss";
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 425px) and (max-width: 768px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 768px) and (max-width: 1024px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1024px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1620px) and (max-width: 2560px) {
    @content;
  }
}
.par {
  display: flex;
  align-items: baseline;
  @include mobile() {
    height: 25px;
  }
}
.auto {
  background: #efefef;
  padding-top: 50px;
  padding-bottom: 50px;
  &-cards {
    display: flex;
    justify-content: space-between;
    width: 100%;
    &-left {
      &__title {
        @include fontStyle(Roboto, normal, 500, 36px, 43px, transparent);
        letter-spacing: 0.03em;
        text-transform: uppercase;
        background: linear-gradient(
          90deg,
          #ff143f 0%,
          #c600dd 49.97%,
          #1b27ff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      &__sub {
        @include fontStyle(Roboto, normal, 400, 24px, 36px, #373737);
        text-transform: uppercase;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      &__btn,
      &__btn-mob {
        button {
          background: #ffffff;
          border-radius: 15px;
          width: 200px;
          height: 70px;
          border: none;
          color: #373737;
          @include fontStyle(Roboto, normal, 600, 18px, 25px, #373737);
          &:hover {
            background: linear-gradient(
              90deg,
              #ff4466 0%,
              #be31ce 49.97%,
              #3641ff 100%
            );
            color: #ffffff;
          }
        }
      }
    }
    &-right {
      // width: 50%;
      img {
        width: 78%;
      }
    }
  }
  @include mobile() {
    padding-top: 20px;
    padding-bottom: 20px;
    &-cards {
      flex-wrap: wrap;
      &-left {
        margin: 0 auto;
        &__title {
          width: 100%;
          font-size: 14px;
          line-height: 17px;
        }
        &__sub {
          padding-bottom: 0;
          padding-top: 0;
          font-size: 12px;
          line-height: 14px;
        }
        &__btn-mob {
          text-align: center;
          button {
            border-radius: 3px;
            width: 96px;
            height: 28px;
            font-size: 9px;
          }
        }
      }
      &-right {
        // width: 100%;
        img {
          width: 54%;
          margin: 0 auto;
          display: flex;
        }
      }
    }
  }
  @include tablet() {
    &-cards {
      flex-wrap: wrap;
      &-left {
        margin: 0 auto;
        &__title {
          width: 100%;
          font-size: 22px;
          line-height: 24px;
        }
        &__sub {
          font-size: 16px;
          line-height: 22px;
        }
        &__btn-mob {
          text-align: center;
          button {
            border-radius: 3px;
            width: 116px;
            height: 38px;
            font-size: 10px;
          }
        }
      }
      &-right {
        // width: 100%;
        img {
          width: 54%;
          margin: 0 auto;
          display: flex;
        }
      }
    }
  }
  @include tablet-1024() {
    &-cards {
      &-right {
        img {
          width: 75%;
        }
      }
      &-left {
        &__title {
          font-size: 20px;
          line-height: 25px;
        }
        &__sub {
          font-size: 14px;
          line-height: 20px;
        }
        &__btn {
          button {
            width: 170px;
            height: 50px;
            border-radius: 7px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.object {
  padding-top: 85px;
  padding-bottom: 55px;
  @include mobile() {
    padding-top: 25px;
    padding-bottom: 0px;
  }
  @include tablet() {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  @include tablet-1024() {
    padding-top: 40px;
    padding-bottom: 25px;
  }
}
.time {
  @include mobile() {
    margin-top: 20px;
  }
}
.object,
.risk {
  &-title {
    @include fontStyle(Roboto, normal, 500, 28px, 34px, #373737);
  }
  &-par {
    @include fontStyle(Roboto, normal, 300, 18px, 22px, #373737);
    span {
      @include fontStyle(Roboto, normal, 900, 24px, 33px, #ffffff);
      letter-spacing: 0.03em;
      background: -webkit-linear-gradient(
        180deg,
        #1b27ff 39%,
        #c600dd 44%,
        #ff143f 69%
      );
      -webkit-background-clip: text;
      -webkit-text-stroke: 2px transparent;
      color: #ffffff;
      padding-right: 10px;
      padding-left: 2px;
    }
  }
  span {
    @include fontStyle(Roboto, normal, 900, 24px, 33px, #ffffff);
    letter-spacing: 0.03em;
    background: -webkit-linear-gradient(
      180deg,
      #1b27ff 61%,
      #c600dd 30%,
      #ff143f 81%
    );
    -webkit-background-clip: text;
    -webkit-text-stroke: 2px transparent;
    color: #ffffff;
    padding-right: 10px;
    padding-left: 2px;
  }
  @include mobile() {
    // padding-top: 25px;
    // padding-bottom: 20px;
    &-title {
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      margin-bottom: 0;
    }
    &-par {
      font-size: 12px;
      line-height: 14px;
      // margin-top: -10px;
      span {
        font-size: 10px;
        line-height: 12px;
        font-weight: 700;
        -webkit-text-stroke: 1px transparent;
      }
    }
    span {
      font-size: 10px;
      line-height: 12px;
      font-weight: 700;
      -webkit-text-stroke: 1px transparent;
    }
  }
  @include tablet() {
    &-title {
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
    &-par {
      font-size: 12px;
      line-height: 14px;
      margin-top: -10px;
      span {
        font-size: 14px;
        line-height: 12px;
        font-weight: 700;
        -webkit-text-stroke: 1px transparent;
      }
    }
    span {
      font-size: 14px;
      line-height: 12px;
      font-weight: 700;
      -webkit-text-stroke: 1px transparent;
    }
  }
  @include tablet-1024() {
    &-title {
      font-size: 20px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
    &-par {
      font-size: 14px;
      line-height: 14px;
      span {
        font-size: 14px;
        line-height: 12px;
        font-weight: 700;
        -webkit-text-stroke: 1px transparent;
      }
    }
  }
}
</style>
